import React from 'react';
import PropTypes from 'prop-types';
import platform from 'platform';
import postal from 'postal';
import ErrorBoundary from '../../shared/error-boundary';

const isEmbedded = platform.name === 'Safari'
  && (platform.product || '').match(/ipod|ipad|iphone/i)
  && +platform.version < 11;

const getModalId = eId => `eventbrite-widget-modal-trigger-${eId}-${Math.round(Math.random() * 1000000)}`;
const getIframeId = eId => `eventbrite-widget-container-${eId}`;

export default function PurchaseTickets(props) {
  const mounted = React.useRef(false);
  const buttonRef = React.useRef();
  const modalId = React.useMemo(() => getModalId(props.eventbriteId), [props.eventbriteId]);

  React.useEffect(() => {
    if (!mounted.current) {
      window.EBWidgets.createWidget({
        widgetType: 'checkout',
        eventId: props.eventbriteId,
        ...(isEmbedded
          ? { modal: true, modalTriggerElementId: modalId }
          : { iframeContainerHeight: 425, iframeContainerId: getIframeId(props.eventbriteId) }
        ),
      });

      postal.subscribe({
        channel: 'livewire-events.commands',
        topic: 'trigger-purchase-ticket',
        callback: () => buttonRef.current.click(),
      });
    }
    return () => {
      mounted.current = true;
    };
  }, [modalId, props.eventbriteId]);

  return (
    <ErrorBoundary>
      {
        isEmbedded ? (
          <a
            ref={buttonRef}
            className="btn btn-primary"
            href={`https://www.eventbrite.com.au/e/${props.eventbriteId}?ref=elink`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {props.buttonText}
          </a>
        ) : (
          <button
            ref={buttonRef}
            type="button"
            className="btn btn-primary"
            id={modalId}
          >
            {props.buttonText}
          </button>
        )
      }
    </ErrorBoundary>
  );
}

PurchaseTickets.propTypes = {
  eventbriteId: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
};

PurchaseTickets.defaultProps = {
  buttonText: 'Purchase tickets',
};
